import DOMPurify from 'dompurify';

/**
 * 商品 / 景點等描述為 CMS 所見即所得編輯器輸出之 HTML；公開端渲染前須以 DOMPurify
 * 白名單淨化（只留格式標籤 + a[href]），防直接打 API 寫入之惡意 HTML（XSS）。
 * 舊純文字資料相容（無標籤即原樣顯示）。連結強制 rel=noopener 避免 tabnabbing。
 */
const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li', 'a', 'span'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

/** 淨化富文本 HTML（詳情頁完整呈現用）。 */
export function sanitizeRichHtml(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

/** 去標籤取純文字（列表摘要用；避免 block 元素破版）。 */
export function htmlToPlainText(html: string): string {
  const text = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  return text.replace(/\s+/g, ' ').trim();
}
